<script>
function parseJsonResponse(res) {
  return res.text().then(function (text) {
    var data = {};
    try {
      data = text ? JSON.parse(text) : {};
    } catch (err) {
      data = { success: false, message: text || "API response ไม่ถูกต้อง" };
    }
    if (!res.ok) {
      throw new Error(data.message || "Request failed");
    }
    return data;
  });
}

function displayStatus(raw) {
  var t = String(raw || "").trim();
  if (t === "") {
    return "—";
  }
  if (t === "1" || t.toUpperCase() === "TRUE" || t.toUpperCase() === "Y") {
    return "Active";
  }
  if (t === "0" || t.toUpperCase() === "FALSE" || t.toUpperCase() === "N") {
    return "Inactive";
  }
  var lower = t.toLowerCase();
  if (["active", "enabled", "on", "yes"].indexOf(lower) !== -1) {
    return "Active";
  }
  if (["inactive", "disabled", "off", "no"].indexOf(lower) !== -1) {
    return "Inactive";
  }
  return t;
}

function isRoleActive(statusRaw) {
  return displayStatus(statusRaw) === "Active";
}

function formatLevel(raw) {
  var t = String(raw || "").trim();
  if (t === "") {
    return "";
  }
  if (/^\d+$/.test(t)) {
    var n = parseInt(t, 10);
    if (n === 1) return "สูง";
    if (n === 2) return "กลาง";
    if (n === 3) return "พื้นฐาน";
  }
  var lower = t.toLowerCase();
  if (lower === "high" || lower === "h") return "สูง";
  if (lower === "medium" || lower === "mid" || lower === "m") return "กลาง";
  if (lower === "low" || lower === "basic" || lower === "l") return "พื้นฐาน";
  return t;
}

function levelSelectValue(raw) {
  var shown = formatLevel(raw);
  if (shown === "สูง") return "high";
  if (shown === "กลาง") return "medium";
  if (shown === "พื้นฐาน") return "basic";
  var lower = String(raw || "").trim().toLowerCase();
  if (lower === "high" || lower === "medium" || lower === "basic") {
    return lower;
  }
  return "medium";
}

function formatDatetime(raw) {
  var t = String(raw || "").trim();
  if (!t) {
    return "—";
  }
  var ts = Date.parse(t.replace(" ", "T"));
  if (isNaN(ts)) {
    return t;
  }
  var d = new Date(ts);
  var pad = function (n) {
    return String(n).padStart(2, "0");
  };
  return pad(d.getDate()) + "/" + pad(d.getMonth() + 1) + "/" + d.getFullYear() + " " + pad(d.getHours()) + ":" + pad(d.getMinutes());
}

function statusSelectValue(raw) {
  var d = displayStatus(raw);
  if (d === "—" || d === "") {
    return "Active";
  }
  if (d === "Active" || d === "Inactive") {
    return d;
  }
  return d;
}

function permList(raw) {
  if (Array.isArray(raw)) {
    return raw.map(function (k) {
      return String(k || "");
    }).filter(Boolean);
  }
  if (raw && typeof raw === "object") {
    return Object.keys(raw).map(function (k) {
      return String(raw[k] || "");
    }).filter(Boolean);
  }
  return [];
}

function formFromRow(row) {
  row = row || {};
  var code = String(row.role_code || "").trim();
  if (!code) {
    code = String(row.id || "");
  }
  return {
    id: String(row.id || ""),
    role_code: code,
    role_name: String(row.role_name || ""),
    description: String(row.description == null ? "" : row.description),
    level: levelSelectValue(row.level),
    status: statusSelectValue(row.status),
    permissions: permList(row.permissions),
  };
}

function emptyRoleForm() {
  return {
    id: "",
    role_code: "",
    role_name: "",
    description: "",
    level: "medium",
    status: "Active",
    permissions: [],
  };
}

export default {
  name: "AdminRoles",
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    var cfg = this.config || {};
    var roles = Array.isArray(cfg.roles) ? cfg.roles.slice() : [];
    return {
      roles: roles,
      dbError: String(cfg.dbError || ""),
      alert: { type: "", message: "" },
      form: emptyRoleForm(),
      formEpoch: 0,
      saving: false,
      deleteTarget: null,
      deleting: false,
    };
  },
  computed: {
    saveUrl: function () {
      return String((this.config && this.config.saveUrl) || "actions/admin/role-save.php");
    },
    updateUrl: function () {
      return String((this.config && this.config.updateUrl) || "actions/admin/role-update.php");
    },
    deleteUrl: function () {
      return String((this.config && this.config.deleteUrl) || "actions/admin/role-delete.php");
    },
    nextRoleCode: function () {
      var max = 0;
      (this.roles || []).forEach(function (row) {
        var m = String(row.role_code || "")
          .trim()
          .toUpperCase()
          .match(/^R(\d+)$/);
        if (m) {
          var n = parseInt(m[1], 10);
          if (!isNaN(n) && n > max) {
            max = n;
          }
        }
      });
      var prefill = String((this.config && this.config.prefillNextRoleCode) || "").trim();
      if (max === 0 && prefill) {
        return prefill;
      }
      return "R" + String(max + 1).padStart(4, "0");
    },
    statTotal: function () {
      return this.roles.length;
    },
    statPermSum: function () {
      return this.roles.reduce(function (sum, row) {
        var n = parseInt(row.perm_count, 10);
        return sum + (isNaN(n) ? 0 : n);
      }, 0);
    },
    statActive: function () {
      return this.roles.filter(function (row) {
        return isRoleActive(row.status);
      }).length;
    },
    statInactive: function () {
      return Math.max(0, this.statTotal - this.statActive);
    },
    permissionGroups: function () {
      var catalog = Array.isArray(this.config && this.config.permissionCatalog) ? this.config.permissionCatalog : [];
      var groups = [];
      var map = {};
      catalog.forEach(function (item) {
        var g = String((item && item.group) || "อื่น");
        if (!map[g]) {
          map[g] = { group: g, items: [] };
          groups.push(map[g]);
        }
        map[g].items.push(item);
      });
      return groups;
    },
    defaultPermissions: function () {
      var list = this.config && this.config.defaultPermissions;
      return Array.isArray(list) ? list.slice() : [];
    },
    isSuperAdminRoleForm: function () {
      return String(this.form.role_name || "")
        .toLowerCase()
        .replace(/\s+/g, "") === "superadmin";
    },
  },
  methods: {
    displayStatus: displayStatus,
    formatLevel: formatLevel,
    formatDatetime: formatDatetime,
    isRoleActive: isRoleActive,
    statusClass: function (raw) {
      var n = displayStatus(raw).toLowerCase();
      if (n === "active" || n === "1") {
        return "bg-success-subtle text-success";
      }
      if (n.indexOf("pending") !== -1 || n.indexOf("wait") !== -1) {
        return "bg-warning-subtle text-warning";
      }
      return "bg-secondary-subtle text-secondary";
    },
    levelClass: function (raw) {
      var l = formatLevel(raw).toLowerCase();
      if (l.indexOf("สูง") !== -1 || l === "high") {
        return "bg-danger-subtle text-danger";
      }
      if (l.indexOf("กลาง") !== -1 || l === "medium" || l === "mid") {
        return "bg-warning-subtle text-warning";
      }
      if (l.indexOf("พื้นฐาน") !== -1 || l === "low" || l === "basic") {
        return "bg-info-subtle text-info";
      }
      return "bg-secondary-subtle text-secondary";
    },
    showAlert: function (type, message) {
      this.alert = { type: type === "success" ? "success" : "danger", message: String(message || "") };
    },
    showModal: function (refName) {
      var el = this.$refs[refName];
      if (!el || !window.bootstrap || !window.bootstrap.Modal) {
        return;
      }
      window.bootstrap.Modal.getOrCreateInstance(el).show();
    },
    hideModal: function (refName) {
      var el = this.$refs[refName];
      var inst;
      if (!el || !window.bootstrap || !window.bootstrap.Modal) {
        return;
      }
      inst = window.bootstrap.Modal.getInstance(el);
      if (inst) {
        inst.hide();
      }
    },
    openCreate: function () {
      this.form = emptyRoleForm();
      this.form.role_code = this.nextRoleCode;
      this.form.permissions = this.defaultPermissions.slice();
      this.formEpoch += 1;
      var self = this;
      this.$nextTick(function () {
        self.showModal("roleModal");
      });
    },
    openEdit: function (row) {
      this.form = formFromRow(row);
      this.formEpoch += 1;
      var self = this;
      this.$nextTick(function () {
        self.showModal("roleModal");
      });
    },
    isPermChecked: function (key) {
      return (this.form.permissions || []).indexOf(key) !== -1;
    },
    togglePerm: function (key, checked) {
      var list = Array.isArray(this.form.permissions) ? this.form.permissions.slice() : [];
      var i = list.indexOf(key);
      if (checked) {
        if (i === -1) {
          list.push(key);
        }
      } else if (i !== -1) {
        list.splice(i, 1);
      }
      this.form.permissions = list;
    },
    toggleGroup: function (items, checked) {
      var self = this;
      (items || []).forEach(function (item) {
        self.togglePerm(String((item && item.key) || ""), checked);
      });
    },
    groupAllChecked: function (items) {
      var self = this;
      if (!items || !items.length) {
        return false;
      }
      return items.every(function (item) {
        return self.isPermChecked(String((item && item.key) || ""));
      });
    },
    openDelete: function (row) {
      this.deleteTarget = row;
      this.showModal("deleteModal");
    },
    saveRole: function () {
      var self = this;
      var form = this.form;
      var name = String(form.role_name || "").trim();
      if (!name) {
        return;
      }
      this.saving = true;
      var rid = String(form.id || "").trim();
      var body = new FormData();
      body.append("role_id", rid);
      body.append("role_code", String(form.role_code || "").trim());
      body.append("role_name", name);
      body.append("description", String(form.description || ""));
      body.append("level", String(form.level || "").trim());
      body.append("status", String(form.status || "Active"));
      body.append("permissions_json", JSON.stringify(Array.isArray(form.permissions) ? form.permissions : []));
      var url = rid ? this.updateUrl : this.saveUrl;
      fetch(url, { method: "POST", body: body, credentials: "same-origin" })
        .then(parseJsonResponse)
        .then(function (data) {
          if (!data || data.success !== true) {
            throw new Error((data && data.message) || "ไม่สามารถบันทึกบทบาทได้");
          }
          var saved = {
            id: rid || String((data && data.role_id) || form.role_code || ""),
            role_code: String(form.role_code || ""),
            role_name: name,
            description: String(form.description || ""),
            level: String(form.level || ""),
            status: String(form.status || "Active"),
            updated_at: new Date().toISOString().slice(0, 19).replace("T", " "),
            perm_count: "0",
            permissions: Array.isArray(data && data.permissions) ? data.permissions : (form.permissions || []).slice(),
            acl_count: String((data && data.acl_count) || (form.permissions || []).length),
          };
          if (rid) {
            self.roles = self.roles.map(function (row) {
              if (String(row.id) !== rid) {
                return row;
              }
              return Object.assign({}, row, saved, { id: rid, perm_count: row.perm_count });
            });
          } else {
            self.roles = [saved].concat(self.roles);
          }
          self.hideModal("roleModal");
          self.showAlert("success", data.message || (rid ? "แก้ไขบทบาทสำเร็จ" : "เพิ่มบทบาทสำเร็จ"));
        })
        .catch(function (err) {
          self.showAlert("danger", err.message || "เกิดข้อผิดพลาดในการบันทึก");
        })
        .finally(function () {
          self.saving = false;
        });
    },
    confirmDelete: function () {
      var self = this;
      var row = this.deleteTarget;
      if (!row || !row.id) {
        return;
      }
      this.deleting = true;
      var body = new FormData();
      body.append("role_id", String(row.id));
      fetch(this.deleteUrl, { method: "POST", body: body, credentials: "same-origin" })
        .then(parseJsonResponse)
        .then(function (data) {
          if (!data || data.success !== true) {
            throw new Error((data && data.message) || "ไม่สามารถลบบทบาทได้");
          }
          self.roles = self.roles.filter(function (item) {
            return String(item.id) !== String(row.id);
          });
          self.deleteTarget = null;
          self.hideModal("deleteModal");
          self.showAlert("success", data.message || "ลบบทบาทสำเร็จ");
        })
        .catch(function (err) {
          self.showAlert("danger", err.message || "เกิดข้อผิดพลาดในการลบข้อมูล");
        })
        .finally(function () {
          self.deleting = false;
        });
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
          <h4 class="mb-sm-0">สิทธิ์การใช้งาน</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript:void(0);">ผู้ดูแลระบบ</a></li>
              <li class="breadcrumb-item active">สิทธิ์การใช้งาน</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div v-if="alert.message" class="alert alert-dismissible fade show material-shadow" :class="alert.type === 'success' ? 'alert-success' : 'alert-danger'" role="alert">
      {{ alert.message }}
      <button type="button" class="btn-close" aria-label="Close" @click="alert.message = ''"></button>
    </div>
    <div v-if="dbError" class="alert alert-danger" role="alert">{{ dbError }}</div>

    <div class="row">
      <div class="col-xxl-3 col-sm-6">
        <div class="card card-animate">
          <div class="card-body">
            <p class="text-uppercase fw-medium text-muted mb-0">จำนวนบทบาททั้งหมด</p>
            <h4 class="mt-3 mb-0">{{ statTotal }} บทบาท</h4>
          </div>
        </div>
      </div>
      <div class="col-xxl-3 col-sm-6">
        <div class="card card-animate">
          <div class="card-body">
            <p class="text-uppercase fw-medium text-muted mb-0">ผู้ใช้รวม (จาก admin_users)</p>
            <h4 class="mt-3 mb-0 text-primary">{{ statPermSum }} คน</h4>
          </div>
        </div>
      </div>
      <div class="col-xxl-3 col-sm-6">
        <div class="card card-animate">
          <div class="card-body">
            <p class="text-uppercase fw-medium text-muted mb-0">บทบาทที่ใช้งาน</p>
            <h4 class="mt-3 mb-0 text-success">{{ statActive }} บทบาท</h4>
          </div>
        </div>
      </div>
      <div class="col-xxl-3 col-sm-6">
        <div class="card card-animate">
          <div class="card-body">
            <p class="text-uppercase fw-medium text-muted mb-0">บทบาทไม่ใช้งาน</p>
            <h4 class="mt-3 mb-0 text-warning">{{ statInactive }} บทบาท</h4>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header border-0 align-items-center d-flex">
        <h4 class="card-title mb-0 flex-grow-1">ตารางสิทธิ์การใช้งาน</h4>
        <div class="flex-shrink-0">
          <button type="button" class="btn btn-success" @click="openCreate">
            <i class="ri-add-line align-bottom me-1"></i> เพิ่มบทบาท
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive table-card">
          <table class="table table-striped-columns table-nowrap align-middle mb-0">
            <thead class="table-light text-muted">
              <tr>
                <th>ชื่อบทบาท</th>
                <th>คำอธิบาย</th>
                <th>ผู้ใช้งาน</th>
                <th>สิทธิ์</th>
                <th>ระดับ</th>
                <th>สถานะ</th>
                <th>อัปเดตล่าสุด</th>
                <th class="text-end">จัดการ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="roles.length === 0">
                <td colspan="8" class="text-muted">ไม่พบข้อมูลบทบาทในฐานข้อมูล</td>
              </tr>
              <tr v-for="row in roles" :key="row.id || row.role_code">
                <td class="fw-medium">{{ row.role_name }}</td>
                <td class="text-wrap" style="white-space: pre-line;">{{ row.description }}</td>
                <td>{{ row.perm_count }}</td>
                <td>{{ row.acl_count || (Array.isArray(row.permissions) ? row.permissions.length : "—") }}</td>
                <td>
                  <span class="badge" :class="levelClass(row.level)">{{ formatLevel(row.level) || "—" }}</span>
                </td>
                <td>
                  <span class="badge" :class="statusClass(row.status)">{{ displayStatus(row.status) }}</span>
                </td>
                <td>{{ formatDatetime(row.updated_at) }}</td>
                <td class="text-end">
                  <button type="button" class="btn btn-sm btn-soft-info" @click="openEdit(row)">แก้ไข</button>
                  <button type="button" class="btn btn-sm btn-soft-danger" @click="openDelete(row)">ลบ</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="modal fade mct-role-modal" ref="roleModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <form class="modal-content" :key="'role-form-' + formEpoch" autocomplete="off" @submit.prevent="saveRole">
          <div class="modal-header bg-light p-3">
            <h5 class="modal-title">{{ form.id ? "แก้ไขบทบาท" : "เพิ่มบทบาท" }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
              <div class="mb-3">
                <label class="form-label" for="mct-admin-role-code">รหัสบทบาท (role_code)</label>
                <input id="mct-admin-role-code" v-model="form.role_code" type="text" class="form-control" readonly>
                <div class="form-text">เมื่อเพิ่มบทบาทใหม่ ระบบจะสร้างรหัส R + ตัวเลข 4 หลักที่ยังไม่ซ้ำ</div>
              </div>
              <div class="mb-3">
                <label class="form-label" for="mct-admin-role-name">ชื่อบทบาท</label>
                <input id="mct-admin-role-name" v-model="form.role_name" type="text" class="form-control" placeholder="เช่น Content Manager" required>
              </div>
              <div class="mb-3">
                <label class="form-label" for="mct-admin-role-desc">คำอธิบาย</label>
                <textarea id="mct-admin-role-desc" v-model="form.description" class="form-control" rows="3" placeholder="คำอธิบายบทบาท"></textarea>
              </div>
              <div class="row g-3">
                <div class="col-md-6">
                  <label class="form-label" for="mct-admin-role-level">ระดับสิทธิ์</label>
                  <select id="mct-admin-role-level" v-model="form.level" class="form-select" required>
                    <option value="high">สูง</option>
                    <option value="medium">กลาง</option>
                    <option value="basic">พื้นฐาน</option>
                    <option v-if="form.level && ['high','medium','basic'].indexOf(form.level) === -1" :value="form.level">{{ form.level }}</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="form-label" for="mct-admin-role-status">สถานะ</label>
                  <select id="mct-admin-role-status" v-model="form.status" class="form-select">
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                    <option v-if="form.status && form.status !== 'Active' && form.status !== 'Inactive'" :value="form.status">{{ form.status }}</option>
                  </select>
                </div>
              </div>
              <div class="mt-4">
                <h6 class="fw-semibold mb-2">สิทธิ์เมนูและการกระทำ</h6>
                <div v-if="isSuperAdminRoleForm" class="alert alert-info py-2 mb-3">
                  Super Admin มีสิทธิ์ทุกอย่างโดยอัตโนมัติ แม้ไม่ได้เลือกในรายการนี้
                </div>
                <div v-if="permissionGroups.length === 0" class="text-muted">ยังไม่มีรายการสิทธิ์</div>
                <div v-for="grp in permissionGroups" :key="grp.group" class="border rounded-3 p-3 mb-3">
                  <div class="form-check mb-2">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'mct-perm-grp-' + grp.group"
                      :checked="groupAllChecked(grp.items)"
                      @change="toggleGroup(grp.items, $event.target.checked)"
                    >
                    <label class="form-check-label fw-medium" :for="'mct-perm-grp-' + grp.group">{{ grp.group }}</label>
                  </div>
                  <div class="row g-2">
                    <div v-for="item in grp.items" :key="item.key" class="col-md-6">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :id="'mct-perm-' + String(item.key).replace(/\./g, '-')"
                          :value="item.key"
                          v-model="form.permissions"
                        >
                        <label class="form-check-label" :for="'mct-perm-' + String(item.key).replace(/\./g, '-')">{{ item.label }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">ยกเลิก</button>
            <button type="submit" class="btn btn-success" :disabled="saving">{{ saving ? "กำลังบันทึก..." : "บันทึก" }}</button>
          </div>
        </form>
      </div>
    </div>

    <div class="modal fade zoomIn" ref="deleteModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mt-2 text-center">
              <h4>ยืนยันการลบบทบาท?</h4>
              <p class="text-muted mx-4 mb-0">จะลบ {{ deleteTarget ? deleteTarget.role_name : "" }} ออกจากระบบ</p>
            </div>
            <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
              <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn w-sm btn-danger" :disabled="deleting" @click="confirmDelete">{{ deleting ? "กำลังลบ..." : "Yes, Delete It!" }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.mct-role-modal .modal-dialog-scrollable {
  height: calc(100vh - 2rem);
  max-height: calc(100vh - 2rem);
  margin: 1rem auto;
}
.mct-role-modal .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.mct-role-modal .modal-body {
  overflow-y: auto;
  min-height: 0;
}
</style>

